// extracted by mini-css-extract-plugin
export default {"wrapper":"clapIcon_wrapper__BoANA"};